<template>
    <keep-alive>
        <CardBoard 
            v-if="state.cases.length" 
            :type="state.type" 
            :items="state.cases" 
        />
    </keep-alive>
</template>

<script setup lang="ts">
import { reactive, onMounted } from "vue";
import CardBoard from "@/components/home/CardBoard.vue";
import CaseService from "@/services/case-service";
import { MOST_NEEDED_SPECIALTY_ID } from "@/services/enum.service";

const props = defineProps({
    donation_type: {
        type: String,
        default: null
    },
    speciality_id: {
        type: [String, Number],
        default: null
    },
    // Show a grid of "most needed" cases instead of a single recommended card.
    most_needed: {
        type: Boolean,
        default: false
    }
});

const state = reactive({
    cases: [],
    type: 'case',
})

// Same query the cases listing runs for the "الأكثر حاجة" speciality, so the
// screen shows the cases that need donations most rather than ones matching the
// completed case's own speciality.
const fetchMostNeededCases = () => {
    CaseService.getCaseCardList({
        page: 1,
        page_size: 9,
        specialty: MOST_NEEDED_SPECIALTY_ID,
    }).then(({ data: { result } }) => {
        state.type = 'cases';
        state.cases = result?.results ?? [];
    });
}

const fetchCases = () => {
   const params: { donation_type?: string; speciality_id?: string | number } =
     props.donation_type === 'waqf' ? { donation_type: 'waqf' } : {};
   if (props.speciality_id) {
     params.speciality_id = props.speciality_id;
   }
   CaseService.getRecommendedCard(1, params).then((response) => {
        state.type = response.data.result[0].type === 'waqf' ? 'endowments' : response.data.type;
        state.cases = response.data.result;
   })
}

onMounted(() => {
    if (props.most_needed) {
        fetchMostNeededCases();
        return;
    }
    fetchCases();
});
</script>